import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingSellClassicStock {
}
ApiEpBillingSellClassicStock.create = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/sell-classic-stock`,
    method: "POST",
});
ApiEpBillingSellClassicStock.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/sell-classic-stock`,
    method: "GET",
});
//# sourceMappingURL=sell_classic_stock.js.map